module.exports = __webpack_public_path__ + "static/media/sf_3400_gray.c15b8220d70daf9bdedae16055876666.png";